import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Modal } from 'components/Elements'
import { QuestionCreateContainer } from './QuestionCreateContainer'

export const QuestionCreate = ({ categoryId, visible, onClose, onSuccess }) => {
  const { t } = useTranslation()

  return (
    <>
      <Modal visible={visible} centered onClose={onClose} title={t('add_question')} size={'lg'}>
        <QuestionCreateContainer categoryId={categoryId} onClose={onClose} onSuccess={onSuccess} />
      </Modal>
    </>
  )
}

QuestionCreate.propTypes = {
  categoryId: PropTypes.number,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
}
